import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header-saldeo-button',
  templateUrl: './header-saldeo-button.component.html',
  styleUrls: ['./header-saldeo-button.component.scss']
})
export class HeaderSaldeoButtonComponent {
  @Input() label!: string;

  constructor(private router: Router) {}

  navigateToSaldeo(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    this.router.navigate(['/pages/saldeo']);
  }
}
